import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var ComponentService = /** @class */ (function () {
    function ComponentService() {
        this.mapViewReady$ = new Subject();
    }
    ComponentService.prototype.mapViewReady = function (mapView) {
        this.mapViewReady$.next(mapView);
    };
    ComponentService.ngInjectableDef = i0.defineInjectable({ factory: function ComponentService_Factory() { return new ComponentService(); }, token: ComponentService, providedIn: "root" });
    return ComponentService;
}());
export { ComponentService };
